import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import fileDownload from 'js-file-download';

type Req = {
  adminUserId: string;
  candidateId: string;
};

type Response = void;

type Return = {
  downloadCandidateCv: (req: Req) => Promise<Response>;
  isDownloading: boolean;
};

export const useDownloadCandidateCv = (): Return => {
  const { adminCandidatesApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const response = await adminCandidatesApi.downloadCandidateCv(
        req.adminUserId,
        req.candidateId,
        {
          responseType: 'blob',
        },
      );
      const fileName =
        response.headers['content-disposition'].match(/attachment; filename=(.*)/)[1] ?? 'cv.pdf';
      fileDownload(response.data, fileName, 'application/pdf');
    },
  });

  return {
    downloadCandidateCv: mutateAsync,
    isDownloading: isPending,
  };
};
